export default `---
slug: spain
country: Spain
countryCode: ESP
continent: Europe
year: 2019
title: "Spain"
description: "The Iberian Peninsula — tapas, flamenco, and the endless summer."
thumbnail: /images/travels/ESP/spain_thumb.jpg
relatedLinks: []
---
![spain](/images/travels/ESP/spain_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Spain and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
